import { RPInstance } from './base';

const certificationApi = {};
const baseUrl = 'common/certification';

// 주민등록번호 인증
certificationApi.checkIdentityNo = (val) => {
  return RPInstance.post(`${baseUrl}/identity/check`, { idNo: val });
};

// 주민등록번호 인증, 출금시
certificationApi.checkIdentityNoInCreate = (val) => {
  return RPInstance.post(`${baseUrl}/identity/check?isCreate=true`, { idNo: val });
};

// 계좌 실명 인증
certificationApi.checkBankAccount = (val) => {
  return RPInstance.post(`${baseUrl}/account/check`, val);
};

// 생년월일 인증
certificationApi.checkBirthDay = (val) => {
  return RPInstance.post(`${baseUrl}/birthday/check`, { birthday: val });
};

export default {
  ...certificationApi,
};
